var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import Async from 'react-select/async';
import { getDefaultStyles } from './utils';
var CustomAsync = function (_a) {
    var styles = _a.styles, error = _a.error, warning = _a.warning, touched = _a.touched, innerRef = _a.innerRef, restProps = __rest(_a, ["styles", "error", "warning", "touched", "innerRef"]);
    var hasError = !!error && !!touched;
    var hasWarning = !!warning && !!touched;
    var selectStyles = useMemo(function () { return styles !== null && styles !== void 0 ? styles : getDefaultStyles({ hasError: hasError, hasWarning: hasWarning }); }, [styles, hasError, hasWarning]);
    return React.createElement(Async, __assign({}, restProps, { styles: selectStyles, ref: innerRef }));
};
export default CustomAsync;
